if (!customElements.get('cart-upsell-carousel')) {
  class CartUpsellCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-upsell-track]');
      this.nav = this.querySelector('[data-upsell-nav]');
      this.prev = this.querySelector('[data-upsell-dir="prev"]');
      this.next = this.querySelector('[data-upsell-dir="next"]');
      if (!this.track) return;

      this.onScroll = () => this.update();
      this.prev?.addEventListener('click', () => this.step(-1));
      this.next?.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.update());
        this.ro.observe(this.track);
      }

      // Images may shift layout once loaded — re-measure then.
      this.track.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.onScroll, { once: true });
      });

      this.update();
    }

    disconnectedCallback() {
      this.ro?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
    }

    step(direction) {
      const card = this.track.querySelector('.cart-upsell__product');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
      const amount = card ? card.offsetWidth + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const overflows = maxScroll > 2;
      if (this.nav) this.nav.hidden = !overflows;
      const x = this.track.scrollLeft;
      this.prev?.toggleAttribute('disabled', x <= 1);
      this.next?.toggleAttribute('disabled', x >= maxScroll - 1);
    }
  }

  customElements.define('cart-upsell-carousel', CartUpsellCarousel);
}
